module.exports = __webpack_public_path__ + "static/media/archive-approvals-icon.5954f6aa.svg";